export interface TruckbookApiErrorDetail {
  code: string
  type: string
  message: string
}

export interface TruckbookApiErrorResponseBody {
  data: {
    timestamp: string
    errors: TruckbookApiErrorDetail[]
  }
  status: string
  message: string
}

export class TruckbookApiResponseError extends Error {
  readonly status: string
  readonly httpStatus: number
  readonly errors: TruckbookApiErrorDetail[]
  readonly timestamp: string
  readonly originalError: unknown

  constructor(body: TruckbookApiErrorResponseBody, httpStatus: number, originalError: unknown) {
    super(body.message)
    this.name = 'TruckbookApiResponseError'
    this.status = body.status
    this.httpStatus = httpStatus
    this.errors = body.data.errors
    this.timestamp = body.data.timestamp
    this.originalError = originalError

    Object.setPrototypeOf(this, TruckbookApiResponseError.prototype)
  }

  get firstCode(): string | undefined {
    return this.errors[0]?.code
  }

  static isApiErrorResponseBody(value: unknown): value is TruckbookApiErrorResponseBody {
    if (typeof value !== 'object' || value === null) return false
    const v = value as Record<string, unknown>
    if (typeof v.status !== 'string' || typeof v.message !== 'string') {
      return false
    }
    const data = v.data as Record<string, unknown> | undefined
    if (!data || typeof data.timestamp !== 'string') return false
    return Array.isArray(data.errors)
  }
}
